<template>
  <div class="rankingIcon" v-if="needsShowing">
    <p class="rankingIcon-text">
      第<span class="rankingIcon-number">{{ number }}</span
      >位
    </p>
  </div>
</template>
<script>
export default {
  name: "RankingIcon",
  props: {
    number: {
      type: Number,
    },
  },
  computed: {
    needsShowing() {
      return this.number !== -1;
    },
  },
};
</script>
<style lang="scss" scoped>
.rankingIcon {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 25%;

  &::before {
    content: "";
    display: block;
    width: 16px;
    height: 11px;
    margin: 0 auto;
    background: url("../../assets/images/_parts/other/ranking.svg") no-repeat
      center/contain;
  }

  .rankingIcon-text {
    font-size: 10px;
    text-align: center;
    color: #333;
    line-height: 1;
    margin-top: 3px;
  }

  .rankingIcon-number {
    font-size: 15px;
    color: #333;
    font-weight: 600;
    margin: 0 2px;
    position: relative;
    top: 1px;
  }

  @include media() {
    &::before {
      width: vw(15);
      height: vw(10);
    }

    .rankingIcon-text {
      font-size: vw(8);
      line-height: 1.2;
      margin-top: vw(1);
    }

    .rankingIcon-number {
      font-size: vw(13);
      margin: 0 vw(1);
      top: vw(1);
    }
  }
}
</style>
